import React, { useState, useEffect } from 'react';

const NetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    // Event listeners for online/offline status
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    // Add event listeners
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Clean up event listeners
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  // Only render the notification when offline
  if (isOnline) return null;

  return (
    <div className="fixed inset-x-0 top-0 z-[100] bg-red-500 text-white p-4 text-center shadow-md">
      <div className="flex items-center justify-center">
        <svg 
          className="w-6 h-6 mr-2" 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24" 
          xmlns="http://www.w3.org/2000/svg"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth="2" 
            d="M12 9v2m0 4h.01m-6.938-9h13.856c1.54 0 2.502 1.667 1.732 3L13.732 21c-.77 1.333-2.694 1.333-3.464 0L3.34 9c-.77-1.333.192-3 1.732-3z"
          ></path>
        </svg>
        <span className="font-medium">No internet connection. Please check your network.</span>
      </div>
    </div>
  );
};

export default NetworkStatus;